<template>
  <div>
    <v-container grid-list-xl fluid class="pa-2 px-3">
      <v-layout row wrap class="pr-5 pl-2">
        <v-flex mb-3 class="pb-0">
          <h3 class="title darkblue--text breadcrumbs">SPENDING REPORT</h3>
          <v-breadcrumbs
            class="px-0 subtitle-2 mt-0 pt-0 pb-1 breadcrumbs-items"
            :items="breadcrumbs"
          ></v-breadcrumbs>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs5 class="text-right pa-0 pt-4 pb-2" v-if="yearFilter">
          <span class="px-0 mt-0 pt-0 grey--text font-weight-500 fs-12 lh-16">
            Filter by :
            {{ listFilter }}
          </span>
        </v-flex>
        <!--        <v-flex xs3 class="text-center pb-0 pt-5 pr-0">-->
        <!--          <v-select-->
        <!--            prepend-inner-icon="filter_list"-->
        <!--            color="primary"-->
        <!--            class="dashSearch filterSearch"-->
        <!--            placeholder="Filter"-->
        <!--            v-model="filter"-->
        <!--            :items="filters"-->
        <!--            item-val.dataIO="val.dataIO"-->
        <!--            item-text="name"-->
        <!--            single-line-->
        <!--            outlined-->
        <!--            dense-->
        <!--            id="filterId"-->
        <!--            @change="changeFilter()"-->
        <!--          ></v-select>-->
        <!--        </v-flex>-->
        <!--        <v-btn-->
        <!--          color="primary"-->
        <!--          class="mt-5"-->
        <!--          dark-->
        <!--          @click="downloadFile()"-->
        <!--          v-if="isBo === false"-->
        <!--        >-->
        <!--          <v-icon size="10px">mdi-download</v-icon> Download-->
        <!--        </v-btn>-->
        <!-- <v-btn
          id="btn-download"
          depressed
          color="thirdblue"
          class="white--text mt-5 pb-0 mr-2"
          @click="exportIOAll"
        >
          <v-icon left dark>vertical_align_bottom</v-icon>
          Download All
        </v-btn>-->
        <!-- <v-btn
          id="btn-download"
          depressed
          color="thirdblue"
          class="white--text mt-5 pb-0"
          @click="exportIO()"
        >
          <v-icon left dark>vertical_align_bottom</v-icon>
          Download All IO
        </v-btn>-->
      </v-layout>
    </v-container>

    <v-layout class="px-5">
      <v-flex xs12 class="pa-0" v-if="code">
        <v-card class="pb-4" v-if="items === undefined || items.length == 0">
          <v-card-title class="primary pa-2 white--text">
            <span id="titleBrand" class="title pl-2"></span>
            <v-spacer></v-spacer>
            <v-icon class="mr-4" color="white" id="removeBudget"
              >keyboard_arrow_down</v-icon
            >
            <v-icon
              color="white"
              class="mr-2"
              id="refreshBudget"
              @click="getData()"
              >refresh</v-icon
            >
          </v-card-title>
          <v-card-text class="pa-3">
            <v-layout row wrap class>
              <v-icon color="primary" class="ml-3 pt-0 bg-info">info</v-icon>
              <span class="pl-2 font-weight-medium subtitle-1 darkblue--text"
                >SPENDING INFORMATION</span
              >
              <v-flex xs12 class="py-0 text-center">No data displayed</v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="pb-3" v-else>
          <v-card-title class="mb-3">
            <v-flex xs9>
              {{ code ? 'TAXONOMY DETAIL' : 'CONSOLIDATED REPORT' }}
            </v-flex>
            <v-flex xs3 class="text-right">
              <v-icon class="mr-4"></v-icon>
              <v-icon id="refresh" @click="getData(year)"> refresh </v-icon>
            </v-flex>
          </v-card-title>
          <v-card-text class="px-3 py-2">
            <v-row class="mt-3">
              <!-- detail taxo -->
              <v-col sm="12" class="px-4 mt-1">
                <template>
                  <v-simple-table fixed-header class="table-taxonomy nav-table">
                    <template v-slot:default>
                      <VuePerfectScrollbar
                        class="drawer-menu--scroll"
                        :settings="scrollSettings"
                      >
                        <thead>
                          <tr>
                            <th class="f-14 white--text sticky-header1">
                              IO Number
                            </th>
                            <th
                              class="f-14 white--text sticky-header2-taxonomy"
                            >
                              Code
                            </th>
                            <th class="f-14 white--text">Entity</th>
                            <th class="f-14 white--text">Brand</th>
                            <th class="f-14 white--text">House</th>
                            <th class="f-14 white--text">Product Hierarchy</th>
                            <th class="f-14 white--text">Budget Owner</th>
                            <th class="f-14 white--text">PIC</th>
                            <th class="f-14 white--text">
                              Cost Center Description
                            </th>
                            <th class="f-14 white--text">Cost Center</th>
                            <th class="f-14 white--text">
                              Cost Element (GL Protein)
                            </th>
                            <th class="f-14 white--text">
                              Cost Element (GL Protein) Desc
                            </th>
                            <th class="f-14 white--text">Material Group</th>
                            <th class="f-14 white--text">Nature Activity</th>
                            <th class="f-14 white--text">Category</th>
                            <th class="f-14 white--text">Pillars</th>
                            <th class="f-14 white--text">Method</th>
                            <th class="f-14 white--text">Campaign</th>
                            <th class="f-14 white--text">BPC Line</th>
                            <th class="f-14 white--text">Start</th>
                            <th class="f-14 white--text">End</th>
                            <th class="f-14 white--text">
                              Activity Description
                            </th>
                            <th
                              v-for="(month, index) in months"
                              :key="index"
                              class="f-14 white--text"
                            >
                              {{ month }}
                            </th>
                            <th class="f-14 white--text">PO</th>
                            <th class="f-14 white--text">Non-PO</th>
                            <th class="f-14 white--text">Remaining IO</th>
                            <th class="f-14 white--text">GR</th>
                            <th class="f-14 white--text">Actual Non-PO</th>
                            <th class="f-14 white--text">Remaining PO</th>
                            <th class="f-14 white--text">Remaining Non-PO</th>
                            <th class="f-14 white--text">Status</th>
                          </tr>
                        </thead>
                        <tbody v-if="items.length > 0">
                          <tr
                            v-for="val in items"
                            :key="val.dataIO.code"
                            :class="bgStatus(val.dataIO.approval_status_desc)"
                          >
                            <td
                              @click="goTo(val)"
                              style="
                                cursor: pointer;
                                text-decoration: underline;
                              "
                              class="sticky-body1 primary--text"
                              :class="bgReject(val.dataIO.approval_status_desc)"
                            >
                              {{
                                val.dataIO.io_number
                                  ? val.dataIO.io_number
                                  : '-'
                              }}
                            </td>
                            <td
                              @click="goTo(val)"
                              style="
                                cursor: pointer;
                                text-decoration: underline;
                              "
                              class="sticky-body2-taxonomy primary--text"
                              :class="bgReject(val.dataIO.approval_status_desc)"
                            >
                              {{ val.dataIO ? val.dataIO.code : '-' }}
                            </td>
                            <td>
                              {{
                                val.dataIO.entity ? val.dataIO.entity.name : '-'
                              }}
                            </td>
                            <td>
                              {{
                                val.dataIO.brand ? val.dataIO.brand.name : '-'
                              }}
                            </td>
                            <td class="text-capitalize">
                              {{
                                val.dataIO.house ? val.dataIO.house.name : '-'
                              }}
                            </td>
                            <td>
                              {{
                                val.dataIO.product
                                  ? val.dataIO.product.material_desc
                                  : '-'
                              }}
                            </td>
                            <td>
                              {{
                                val.dataIO.budgetOwner
                                  ? val.dataIO.budgetOwner.desc
                                  : '-'
                              }}
                            </td>
                            <td class="text-capitalize">
                              {{ val.dataIO ? val.dataIO.pic : '-' }}
                            </td>
                            <td class="text-capitalize">
                              <span v-if="val.dataIO.taxonomy">
                                {{
                                  val.dataIO.taxonomy.costCenter
                                    ? val.dataIO.taxonomy.costCenter.desc
                                    : '-'
                                }}
                              </span>
                              <span v-else>{{ '-' }}</span>
                            </td>
                            <td>
                              <span v-if="val.dataIO.taxonomy">
                                {{
                                  val.dataIO.taxonomy.costCenter
                                    ? val.dataIO.taxonomy.costCenter.code
                                    : '-'
                                }}
                              </span>
                              <span v-else>{{ '-' }}</span>
                            </td>
                            <td>
                              <span v-if="val.dataIO.taxonomy">
                                {{
                                  val.dataIO.taxonomy.costElement
                                    ? val.dataIO.taxonomy.costElement.code
                                    : '-'
                                }}
                              </span>
                              <span v-else>{{ '-' }}</span>
                            </td>
                            <td>
                              <span v-if="val.dataIO.taxonomy">
                                {{
                                  val.dataIO.taxonomy.costElement
                                    ? val.dataIO.taxonomy.costElement.desc
                                    : '-'
                                }}
                              </span>
                              <span v-else>{{ '-' }}</span>
                            </td>
                            <td>
                              {{
                                val.dataIO.taxonomy
                                  ? val.dataIO.taxonomy.mat_group
                                  : '-'
                              }}
                            </td>
                            <td>
                              <span v-if="val.dataIO.taxonomy">
                                {{
                                  val.dataIO.taxonomy.costCenter
                                    ? val.dataIO.taxonomy.costCenter.costNature
                                        .nature_activity
                                    : '-'
                                }}
                              </span>
                              <span v-else>{{ '-' }}</span>
                            </td>
                            <td class="text-capitalize">
                              <span v-if="val.dataIO.taxonomy">
                                {{
                                  val.dataIO.taxonomy.costCenter
                                    ? val.dataIO.taxonomy.costCenter.costNature
                                        .category
                                    : '-'
                                }}
                              </span>
                              <span v-else>{{ '-' }}</span>
                            </td>
                            <td class="text-capitalize">
                              {{ val.dataIO ? val.dataIO.pillars : '-' }}
                            </td>
                            <td class="text-capitalize">
                              {{ val.dataIO ? val.dataIO.method : '-' }}
                            </td>
                            <td>
                              {{ val.dataIO ? val.dataIO.campaign : '-' }}
                            </td>
                            <td>
                              {{
                                val.dataIO.taxonomy
                                  ? val.dataIO.taxonomy.bpc
                                  : '-'
                              }}
                            </td>
                            <td>
                              {{
                                val.dataIO.start
                                  ? formatDate(val.dataIO.start)
                                  : '-'
                              }}
                            </td>
                            <td>
                              {{
                                val.dataIO.end
                                  ? formatDate(val.dataIO.end)
                                  : '-'
                              }}
                            </td>
                            <td>
                              {{
                                val.dataIO.activity_desc
                                  ? val.dataIO.activity_desc
                                  : '-'
                              }}
                            </td>
                            <td
                              v-for="amount in val.dataIO.amount"
                              :key="amount.month"
                              class="text-right"
                            >
                              {{ amount.value ? idr(amount.value) : '-' }}
                            </td>
                            <td class="text-right">
                              {{ val.dataIO.po ? idr(val.dataIO.po) : '-' }}
                            </td>
                            <td class="text-right">
                              {{
                                val.dataIO.non_po ? idr(val.dataIO.non_po) : '-'
                              }}
                            </td>
                            <td class="text-right">
                              {{
                                val.dataIO.remainingIo
                                  ? idr(val.dataIO.remainingIo)
                                  : '-'
                              }}
                            </td>
                            <td class="text-right">
                              {{ val.dataIO.gr ? idr(val.dataIO.gr) : '-' }}
                            </td>
                            <td class="text-right">
                              {{
                                val.dataIO.actualNonPo
                                  ? idr(val.dataIO.actualNonPo)
                                  : '-'
                              }}
                            </td>
                            <td class="text-right">
                              {{
                                val.dataIO.remainingPo
                                  ? idr(val.dataIO.remainingPo)
                                  : '-'
                              }}
                            </td>
                            <td class="text-right">
                              {{
                                val.dataIO.remainingNonPo
                                  ? idr(val.dataIO.remainingNonPo)
                                  : '-'
                              }}
                            </td>
                            <td class="text-uppercase">
                              {{ val.dataIO.approval_status_desc }}
                            </td>
                          </tr>
                          <tr class="bgTotal">
                            <td
                              class="
                                sticky-body1
                                border-x-0
                                font-weight-bold
                                text-right
                                sticky-amount
                              "
                              style="z-index: 2 !important"
                            ></td>
                            <td
                              class="
                                font-weight-bold
                                text-right
                                border-l-0
                                sticky-amount sticky-body2-taxonomy
                              "
                              style="z-index: 2 !important"
                            >
                              TOTAL
                            </td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td class="border-x-0 sticky-amount"></td>
                            <td
                              class="
                                border-x-0
                                text-right
                                font-weight-bold
                                sticky-amount
                              "
                            ></td>
                            <template v-for="month in formattedMonths">
                              <td
                                class="
                                  font-weight-bold
                                  text-right
                                  sticky-amount
                                "
                                :key="month.text"
                              >
                                {{ totalAmountTaxo(items, month.value) }}
                              </td>
                            </template>
                            <td
                              class="font-weight-bold text-right sticky-amount"
                            >
                              {{ totalAmountForTaxo(items, 'po') }}
                            </td>
                            <td
                              class="font-weight-bold text-right sticky-amount"
                            >
                              {{ totalAmountForTaxo(items, 'non_po') }}
                            </td>
                            <td
                              class="font-weight-bold text-right sticky-amount"
                            >
                              {{ totalAmountForTaxo(items, 'remainingIo') }}
                            </td>
                            <td
                              class="font-weight-bold text-right sticky-amount"
                            >
                              {{ totalAmountForTaxo(items, 'gr') }}
                            </td>
                            <td
                              class="font-weight-bold text-right sticky-amount"
                            >
                              {{ totalAmountForTaxo(items, 'actualNonPo') }}
                            </td>
                            <td
                              class="font-weight-bold text-right sticky-amount"
                            >
                              {{ totalAmountForTaxo(items, 'remainingPo') }}
                            </td>
                            <td
                              class="font-weight-bold text-right sticky-amount"
                            >
                              {{ totalAmountForTaxo(items, 'remainingNonPo') }}
                            </td>
                            <td colspan="2" class="sticky-amount"></td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="45" class="text-center pt-2">
                              <span>No Data Displayed</span>
                            </td>
                          </tr>
                        </tbody>
                      </VuePerfectScrollbar>
                    </template>
                  </v-simple-table>
                </template>
              </v-col>
            </v-row>
            <!-- //List Io -->
          </v-card-text>
          <v-card-actions class="text-right">
            <v-spacer></v-spacer>
            <v-flex xs2 right class="mr-2">
              <v-btn id="btn-back" dark color="red" @click="prevPage">
                Back
              </v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 class="pa-0" v-else>
        <!-- consolidated report -->
        <v-card class="pb-3 mb-10">
          <v-card-title class="mb-3">
            <v-flex xs9>
              {{ code ? 'TAXONOMY DETAIL' : 'CONSOLIDATED REPORT' }}
            </v-flex>
            <v-flex xs3 class="text-right">
              <v-icon class="mr-4"></v-icon>
              <v-icon id="refresh" @click="getCosolidatedReport()">
                refresh
              </v-icon>
            </v-flex>
          </v-card-title>
          <v-card-text class="px-3 py-2">
            <v-row class="mt-3">
              <!-- consolidate -->
              <v-spacer></v-spacer>
              <v-btn color="primary" dark @click="downloadFile()" class="mr-4">
                <v-icon size="10px">mdi-download</v-icon> Download
              </v-btn>
              <v-col sm="12" class="px-4">
                <v-data-table
                  class="mt-1 nav-table table-po po-monitoring-table"
                  :headers="headers"
                  :items="itemConsolidate"
                  :options.sync="options"
                  :server-items-length="totalItems"
                  :footer-props="{
                    itemsPerPageOptions: [10, 25, 50, 100]
                  }"
                >
                  <template v-slot:header>
                    <thead>
                      <tr>
                        <th class="f-14 white--text sticky-header1">
                          IO Number
                          <filter-column
                            field="io_number"
                            :indexItem="0"
                            @searchColumn="searchCln"
                            @sortBy="sortBy"
                            :listFilter="itemFilterCheck.io_number"
                            @checkColumn="checkColumn"
                          />
                        </th>
                        <th class="f-14 white--text sticky-header2">
                          Code
                          <filter-column
                            field="nav_code"
                            :indexItem="1"
                            @searchColumn="searchCln"
                            @sortBy="sortBy"
                            :listFilter="itemFilterCheck.nav_code"
                            @checkColumn="checkColumn"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Year
                          <filter-column
                            field="year"
                            :indexItem="20"
                            :columnType="true"
                            @searchColumn="searchCln"
                            @sortBy="sortBy"
                            :listFilter="itemFilterCheck.year"
                            @checkColumn="checkColumn"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Entity
                          <filter-column
                            field="entity"
                            :indexItem="2"
                            @searchColumn="searchCln"
                            :listFilter="itemFilterCheck.entity"
                            @checkColumn="checkColumn"
                            @sortBy="sortBy"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Brand
                          <filter-column
                            field="brand"
                            :indexItem="3"
                            @searchColumn="searchCln"
                            :listFilter="itemFilterCheck.brand"
                            @checkColumn="checkColumn"
                            @sortBy="sortBy"
                          />
                        </th>
                        <th class="f-14 white--text">
                          House
                          <filter-column
                            field="house"
                            :indexItem="4"
                            @searchColumn="searchCln"
                            :listFilter="itemFilterCheck.house"
                            @checkColumn="checkColumn"
                            @sortBy="sortBy"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Department
                          <filter-column
                            field="department"
                            :indexItem="24"
                            @searchColumn="searchCln"
                            :listFilter="itemFilterCheck.department"
                            @checkColumn="checkColumn"
                            @sortBy="sortBy"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Category
                          <filter-column
                            field="category"
                            :indexItem="25"
                            @searchColumn="searchCln"
                            :listFilter="itemFilterCheck.category"
                            @checkColumn="checkColumn"
                            @sortBy="sortBy"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Product Hierarchy
                          <filter-column
                            field="product_hierarchy"
                            :indexItem="5"
                            @searchColumn="searchCln"
                            :listFilter="itemFilterCheck.product_hierarchy"
                            @checkColumn="checkColumn"
                            @sortBy="sortBy"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Budget Owner
                          <filter-column
                            field="budget_owner"
                            :indexItem="21"
                            @searchColumn="searchCln"
                            :listFilter="itemFilterCheck.budget_owner"
                            @checkColumn="checkColumn"
                            @sortBy="sortBy"
                          />
                        </th>
                        <th class="f-14 white--text text-center">
                          PIC
                          <filter-column
                            :indexItem="6"
                            @searchColumn="searchCln"
                            field="pic"
                            @sortBy="sortBy"
                            :listFilter="itemFilterCheck.pic"
                            @checkColumn="checkColumn"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Cost Center Description
                          <filter-column
                            :indexItem="7"
                            @searchColumn="searchCln"
                            :listFilter="itemFilterCheck.cc_desc"
                            @checkColumn="checkColumn"
                            @sortBy="sortBy"
                            field="cc_desc"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Cost Center
                          <filter-column
                            field="cost_center"
                            :indexItem="8"
                            @searchColumn="searchCln"
                            :listFilter="itemFilterCheck.cost_center"
                            @checkColumn="checkColumn"
                            @sortBy="sortBy"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Cost Element (GL Protein)
                          <filter-column
                            field="cost_element"
                            :indexItem="9"
                            @searchColumn="searchCln"
                            :listFilter="itemFilterCheck.cost_element"
                            @checkColumn="checkColumn"
                            @sortBy="sortBy"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Cost Element (GL Protein) Desc
                          <filter-column
                            :indexItem="10"
                            @searchColumn="searchCln"
                            :listFilter="itemFilterCheck.ce_desc"
                            @checkColumn="checkColumn"
                            @sortBy="sortBy"
                            field="ce_desc"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Material Group
                          <filter-column
                            :indexItem="11"
                            @searchColumn="searchCln"
                            :listFilter="itemFilterCheck.material_group"
                            @checkColumn="checkColumn"
                            @sortBy="sortBy"
                            field="material_group"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Nature Activity
                          <filter-column
                            :indexItem="12"
                            @searchColumn="searchCln"
                            @checkColumn="checkColumn"
                            :listFilter="itemFilterCheck.nature_activity"
                            @sortBy="sortBy"
                            field="nature_activity"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Taxonomy Category
                          <filter-column
                            :indexItem="22"
                            @searchColumn="searchCln"
                            @checkColumn="checkColumn"
                            :listFilter="itemFilterCheck.category"
                            @sortBy="sortBy"
                            field="taxonomy_category"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Pillars
                          <filter-column
                            :indexItem="13"
                            @searchColumn="searchCln"
                            field="pillars"
                            @sortBy="sortBy"
                            @checkColumn="checkColumn"
                            :listFilter="itemFilterCheck.pillars"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Method
                          <filter-column
                            :indexItem="14"
                            @searchColumn="searchCln"
                            field="method"
                            @sortBy="sortBy"
                            @checkColumn="checkColumn"
                            :listFilter="itemFilterCheck.method"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Campaign
                          <filter-column
                            :indexItem="15"
                            @searchColumn="searchCln"
                            field="campaign"
                            @sortBy="sortBy"
                            :listFilter="itemFilterCheck.campaign"
                            @checkColumn="checkColumn"
                          />
                        </th>
                        <th class="f-14 white--text">
                          BPC Line
                          <filter-column
                            :indexItem="16"
                            @searchColumn="searchCln"
                            :listFilter="itemFilterCheck.bpc_line"
                            @sortBy="sortBy"
                            field="bpc_line"
                            @checkColumn="checkColumn"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Start
                          <filter-column
                            :indexItem="17"
                            @searchColumn="searchCln"
                            field="start"
                            @sortBy="sortBy"
                            :listFilter="itemFilterCheck.start"
                            @checkColumn="checkColumn"
                          />
                        </th>
                        <th class="f-14 white--text">
                          End
                          <filter-column
                            :indexItem="18"
                            @searchColumn="searchCln"
                            field="end"
                            @sortBy="sortBy"
                            :listFilter="itemFilterCheck.end"
                            @checkColumn="checkColumn"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Activity Description
                          <filter-column
                            :indexItem="19"
                            @searchColumn="searchCln"
                            field="activity_desc"
                            @sortBy="sortBy"
                            :listFilter="itemFilterCheck.activity_desc"
                            @checkColumn="checkColumn"
                          />
                        </th>
                        <th
                          v-for="(month, index) in months"
                          :key="index"
                          class="f-14 white--text"
                        >
                          {{ month }}
                          <filter-column
                            :columnType="true"
                            :indexItem="index"
                            @searchColumn="searchClnmonth"
                            :listFilter="itemFilterCheck[monthsCheck[index]]"
                            @sortBy="sortBy"
                            :field="monthsCheck[index]"
                            @checkColumn="checkMonthColumn"
                          />
                        </th>
                        <th class="f-14 white--text">
                          PO
                          <filter-column
                            field="po"
                            :indexItem="26"
                            :columnType="true"
                            @searchColumn="searchCln"
                            @sortBy="sortBy"
                            :listFilter="itemFilterCheck.po"
                            @checkColumn="checkColumn"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Non-PO
                          <filter-column
                            field="non_po"
                            :indexItem="27"
                            :columnType="true"
                            @searchColumn="searchCln"
                            @sortBy="sortBy"
                            :listFilter="itemFilterCheck.non_po"
                            @checkColumn="checkColumn"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Remaining IO
                          <filter-column
                            field="remaining_io"
                            :indexItem="28"
                            :columnType="true"
                            @searchColumn="searchCln"
                            @sortBy="sortBy"
                            :listFilter="itemFilterCheck.remaining_io"
                            @checkColumn="checkColumn"
                          />
                        </th>
                        <th class="f-14 white--text">
                          GR
                          <filter-column
                            field="gr"
                            :indexItem="29"
                            :columnType="true"
                            @searchColumn="searchCln"
                            @sortBy="sortBy"
                            :listFilter="itemFilterCheck.gr"
                            @checkColumn="checkColumn"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Actual Non-PO
                          <filter-column
                            field="actual_non_po"
                            :indexItem="30"
                            :columnType="true"
                            @searchColumn="searchCln"
                            @sortBy="sortBy"
                            :listFilter="itemFilterCheck.actual_non_po"
                            @checkColumn="checkColumn"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Remaining PO
                          <filter-column
                            field="remaining_po"
                            :indexItem="31"
                            :columnType="true"
                            @searchColumn="searchCln"
                            @sortBy="sortBy"
                            :listFilter="itemFilterCheck.remaining_po"
                            @checkColumn="checkColumn"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Remaining Non-PO
                          <filter-column
                            field="remaining_non_po"
                            :indexItem="32"
                            :columnType="true"
                            @searchColumn="searchCln"
                            @sortBy="sortBy"
                            :listFilter="itemFilterCheck.remaining_non_po"
                            @checkColumn="checkColumn"
                          />
                        </th>
                        <th class="f-14 white--text">
                          Status
                          <filter-column
                            field="status"
                            :indexItem="23"
                            @searchColumn="searchCln"
                            :listFilter="itemFilterCheck.status"
                            @checkColumn="checkColumn"
                            @sortBy="sortBy"
                          />
                        </th>
                      </tr>
                    </thead>
                  </template>
                  <template v-slot:body="{ items }">
                    <tbody v-if="items.length > 0">
                      <tr v-for="(item, index) in items" :key="index">
                        <td class="sticky-body1">
                          {{ item.io_number ? item.io_number : '-' }}
                        </td>
                        <td class="sticky-body2">
                          {{ item.nav_code ? item.nav_code : '-' }}
                        </td>
                        <td>
                          {{ item.year ? item.year : '-' }}
                        </td>
                        <td>
                          {{ item.entity ? item.entity : '-' }}
                        </td>
                        <td>
                          {{ item.brand ? item.brand : '-' }}
                        </td>
                        <td>
                          {{ item.house ? item.house : '-' }}
                        </td>
                        <td>
                          {{ item.department ? item.department : '-' }}
                        </td>
                        <td>
                          {{ item.category ? item.category : '-' }}
                        </td>
                        <td>
                          {{
                            item.product_hierarchy
                              ? item.product_hierarchy
                              : '-'
                          }}
                        </td>
                        <td>
                          {{ item.budget_owner ? item.budget_owner : '-' }}
                        </td>
                        <td>
                          {{ item.pic || '-' }}
                        </td>
                        <td>
                          {{ item.cc_desc || '-' }}
                        </td>
                        <td>
                          {{ item.cost_center || '-' }}
                        </td>
                        <td>
                          {{ item.cost_element || '-' }}
                        </td>
                        <td>
                          {{ item.ce_desc || '-' }}
                        </td>
                        <td>
                          {{ item.material_group || '-' }}
                        </td>
                        <td>
                          {{ item.nature_activity || '-' }}
                        </td>
                        <td>
                          {{ item.taxonomy_category || '-' }}
                        </td>
                        <td>
                          {{ item ? item.pillars : '-' }}
                        </td>
                        <td>
                          {{ item ? item.method : '-' }}
                        </td>
                        <td>
                          {{ item ? item.campaign || '-' : '-' }}
                        </td>
                        <td>
                          {{ item.bpc_line || '-' }}
                        </td>
                        <td>
                          {{ item.start ? formatDate(item.start) : '-' }}
                        </td>
                        <td>
                          {{ item.start ? formatDate(item.end) : '-' }}
                        </td>
                        <td>
                          {{ item.activity_desc ? item.activity_desc : '-' }}
                        </td>
                        <template v-for="amount in monthsCheck">
                          <td :key="amount" class="text-right">
                            {{ idr(item[amount]) || '-' }}
                          </td>
                        </template>
                        <!-- <td class="text-right">
                          {{ item.q1 ? idr(item.q1) : '-' }}
                        </td>
                        <td class="text-right">
                          {{ item.q2 ? idr(item.q2) : '-' }}
                        </td>
                        <td class="text-right">
                          {{ item.q3 ? idr(item.q3) : '-' }}
                        </td>
                        <td class="text-right">
                          {{ item.q4 ? idr(item.q4) : '-' }}
                        </td> 
                        <td class="text-right">
                          {{ item.full_year_io ? idr(item.full_year_io) : '-' }}
                        </td> -->
                        <td class="text-right">
                          {{ item.po ? idr(item.po) : '-' }}
                        </td>
                        <td class="text-right">
                          {{ item.non_po ? idr(item.non_po) : '-' }}
                        </td>
                        <td class="text-right">
                          {{ item.remaining_io ? idr(item.remaining_io) : '-' }}
                        </td>
                        <td class="text-right">
                          {{ item.gr ? idr(item.gr) : '-' }}
                        </td>
                        <td class="text-right">
                          {{
                            item.actual_non_po ? idr(item.actual_non_po) : '-'
                          }}
                        </td>
                        <td class="text-right">
                          {{ item.remaining_po ? idr(item.remaining_po) : '-' }}
                        </td>
                        <td class="text-right">
                          {{
                            item.remaining_non_po
                              ? idr(item.remaining_no_po)
                              : '-'
                          }}
                        </td>
                        <td class="text-uppercase">
                          {{ item.status ? item.status : '-' }}
                        </td>
                      </tr>
                      <tr class="bgTotal" v-if="options.page === lastPage">
                        <td
                          class="
                            sticky-body1
                            border-r-0
                            font-weight-bold
                            sticky-amount sticky-body1
                          "
                          style="z-index: 2 !important"
                        ></td>
                        <td
                          class="
                            font-weight-bold
                            text-right
                            border-l-0
                            sticky-amount sticky-body2
                          "
                          style="z-index: 2 !important"
                        >
                          TOTAL
                        </td>
                        <td colspan="23" class="border-x-0 sticky-amount"></td>
                        <template v-for="month in monthsCheck">
                          <td
                            class="font-weight-bold text-right sticky-amount"
                            :key="month"
                          >
                            <!-- {{ totalAmount(month.value) }} -->
                            {{ idr(itemAmount[month]) }}
                          </td>
                        </template>
                        <!-- <td class="font-weight-bold text-right sticky-amount">
                          {{ idr(itemAmount.q1) }}
                        </td>
                        <td class="font-weight-bold text-right sticky-amount">
                          {{ idr(itemAmount.q2) }}
                        </td>
                        <td class="font-weight-bold text-right sticky-amount">
                          {{ idr(itemAmount.q3) }}
                        </td>
                        <td class="font-weight-bold text-right sticky-amount">
                          {{ idr(itemAmount.q4) }}
                        </td>
                        <td class="font-weight-bold text-right sticky-amount">
                          {{ idr(itemAmount.fullYearIo) }}
                        </td> -->
                        <td class="font-weight-bold text-right sticky-amount">
                          {{ idr(itemAmount.po) }}
                        </td>
                        <td class="font-weight-bold text-right sticky-amount">
                          {{ idr(itemAmount.non_po) }}
                        </td>
                        <td class="font-weight-bold text-right sticky-amount">
                          {{ idr(itemAmount.remainingIo) }}
                        </td>
                        <td class="font-weight-bold text-right sticky-amount">
                          {{ idr(itemAmount.gr) }}
                        </td>
                        <td class="font-weight-bold text-right sticky-amount">
                          {{ idr(itemAmount.actual_non_po) }}
                        </td>
                        <td class="font-weight-bold text-right sticky-amount">
                          {{ idr(itemAmount.remainingPo) }}
                        </td>
                        <td class="font-weight-bold text-right sticky-amount">
                          {{ idr(itemAmount.remainingNonPo) }}
                        </td>
                        <td colspan="2" class="sticky-amount"></td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="47" class="text-center">
                          No data displayed
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <!-- //List Io -->
          </v-card-text>
          <v-card-actions class="text-right">
            <v-spacer></v-spacer>
            <v-flex xs2 right class="mr-2">
              <v-btn id="btn-back" dark color="red" @click="prevPage">
                Back
              </v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <progress-dialog
      :show="progressDialogLoading"
      text="Please wait"
    ></progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import ACLMixin from '../../../mixins/ACLMixin';
import Swal from 'sweetalert2';
import moment from 'moment';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import filterColumn from '../../../components/filterColumn/consolidate';
import LoginAsMixin from '@/mixins/LoginAsMixin';

export default {
  name: 'SpendingReportIndex',
  components: {
    'progress-dialog': ProgressDialog,
    VuePerfectScrollbar,
    'filter-column': filterColumn
  },
  mixins: [ACLMixin, LoginAsMixin],
  props: ['code', 'yearFilter', 'divId', 'houseId', 'deptId', 'boId'],
  data() {
    return {
      search: [],
      searchmonth: [],
      sortColumn: '',
      sortType: '',
      initializing: false,
      scrollSettings: {
        maxScrollbarLength: 340
      },
      scrollSettingsEdit: {
        maxScrollbarLength: 220
      },
      timeout: null,
      progressDialogLoading: true,
      breadcrumbs: [
        {
          text: 'SPENDING',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: this.code ? 'TAXONOMY DETAIL' : 'CONSOLIDATED REPORT',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      items: [],
      profile: {},
      user: {},
      profile_id: localStorage.getItem('profile_id'),
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
        'Q1',
        'Q2',
        'Q3',
        'Q4',
        'Full Year IO'
      ],
      monthsCheck: [
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december',
        'q1',
        'q2',
        'q3',
        'q4',
        'full_year_io'
      ],
      panel: true,
      // consolidate
      totalItems: 0,
      options: {
        itemsPerPage: 10
      },
      lastPage: 0,
      itemConsolidate: [],
      headers: [],
      baseUrl: process.env.VUE_APP_BASE_URL,
      itemFilter: {},
      listFilter: '',
      itemFilterCheck: [],
      itemAmount: {},
      ceklisSearch: [],
      ceklismonthSearch: []
      // headers: [
      //   {
      //     text: 'Year',
      //     value: 'year',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'IO Number',
      //     value: 'io_number',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'Code',
      //     value: 'code',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'Entity',
      //     value: 'entity',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'Brand',
      //     value: 'brand',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'House',
      //     value: 'house',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'Product Hierarchy',
      //     value: 'productHierarchy',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'Budget Owner',
      //     value: 'budgetOwner',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'PIC',
      //     value: 'pic',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'Cost Center Description',
      //     value: 'costCenterDesc',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'Cost Center',
      //     value: 'costCenter',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'Cost Element (GL Protein)',
      //     value: 'costElement',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'Cost Element (GL Protein) Description',
      //     value: 'costElementDesc',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'Material Group',
      //     value: 'mat',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'Nature Activity',
      //     value: 'natureActivity',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'Category',
      //     value: 'category',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'Pillars',
      //     value: 'pillars',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'Method',
      //     value: 'method',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'Campaign',
      //     value: 'gr',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'BPC Line',
      //     value: 'bpc',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'BPC Line',
      //     value: 'bpc',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'BPC Line',
      //     value: 'bpc',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   },
      //   {
      //     text: 'BPC Line',
      //     value: 'bpc',
      //     class: 'white--text fs-14 font-weight-medium',
      //     sortable: false
      //   }
      // ]
    };
  },
  computed: {
    formattedMonths() {
      return this.months.map((item, index) => ({
        text: item,
        value:
          index === 16
            ? this.code
              ? 'Total'
              : 'Full Year IO'
            : item.toLowerCase()
      }));
    },
    year() {
      // We will see what `params` is shortly
      return this.$route.params.year;
    },
    filterYear() {
      return this.yearFilter ? this.yearFilter.split('-') : '';
    },
    division_ids() {
      return this.divId !== 'division' ? this.divId.split(',') : '';
    },
    house_ids() {
      return this.houseId !== 'house' ? this.houseId.split(',') : '';
    },
    dept_ids() {
      return this.deptId !== 'dept' ? this.deptId.split(',') : '';
    },
    bo_ids() {
      return this.boId !== 'bo' ? this.boId.split(',') : '';
    }
  },
  mounted() {
    if (this.code) {
      this.getData();
    } else {
      this.getCosolidatedReport();
    }
  },
  watch: {
    'options.itemsPerPage'() {
      this.getCosolidatedReport();
    },
    'options.page'() {
      this.getCosolidatedReport();
    },
    search: {
      handler() {
        this.getCosolidatedReport();
      },
      deep: true
    }
  },
  methods: {
    getData() {
      this.progressDialogLoading = true;
      let year = moment(this.year).format('YYYY');
      let params = {
        year: year,
        code_cost_element: this.code
      };
      this.$store
        .dispatch('spending/detailTaxo', params)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.items = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.data.error, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_ren, 'error');
        });
    },
    filtered() {
      let div =
        this.divId !== 'division'
          ? this.itemFilter.divisions.join(' / ')
          : 'All Division';
      let house =
        this.houseId !== 'house'
          ? this.itemFilter.houses.join(' / ')
          : this.isLoggedInAsHN || div === 'HN'
          ? 'All Department'
          : 'All House';
      let dept =
        this.deptId !== 'dept'
          ? this.itemFilter.departments.join(' / ')
          : this.isLoggedInAsHN || div === 'HN'
          ? 'All Category'
          : 'All Department';
      let bo =
        this.boId !== 'bo'
          ? this.itemFilter.budgetOwners.join(' / ')
          : 'All Budget Owner';
      this.listFilter =
        this.yearFilter +
        ' / ' +
        div +
        ' / ' +
        house +
        ' / ' +
        dept +
        ' / ' +
        bo;
    },
    totalAmount(month) {
      return this.itemConsolidate
        .reduce((total, items) => {
          const value = +(
            items.amount.find(
              val => val.month.toLowerCase() === month.toLowerCase()
            ) || {}
          ).value;
          total += value;
          return total;
        }, 0)
        .toLocaleString('id');
    },
    totalAmountFor(key) {
      return this.itemConsolidate
        .reduce((total, val) => {
          const value = +(val[key] || 0);
          total += value;
          return total;
        }, 0)
        .toLocaleString('id');
    },
    totalAmountTaxo(item, month) {
      return item
        .reduce((total, items) => {
          const value = +(
            items.dataIO.amount.find(
              val => val.month.toLowerCase() === month.toLowerCase()
            ) || {}
          ).value;
          total += value;
          return total;
        }, 0)
        .toLocaleString('id');
    },
    totalAmountForTaxo(item, key) {
      return item
        .reduce((total, val) => {
          const value = +(val.dataIO[key] || 0);
          total += value;
          return total;
        }, 0)
        .toLocaleString('id');
    },
    bgStatus(val) {
      if (val == 'rejected') {
        return 'softpink';
      } else {
        return 'white';
      }
    },
    bgReject(val) {
      if (val == 'rejected') {
        return 'bgPink';
      } else {
        return '';
      }
    },
    goTo(item) {
      let budget_code = item.dataIO.id;
      this.$router.push({
        name: 'one-pager',
        params: { id: budget_code }
      });
    },
    prevPage() {
      this.$router.go(-1);
    },
    // consolidate
    getCosolidatedReport() {
      this.progressDialogLoading = true;
      let { page, itemsPerPage } = this.options;
      this.progressDialogLoading = true;
      let params = {
        type: 'report',
        profileId: this.profile_id,
        startYear: this.filterYear[0],
        endYear: this.filterYear[1],
        divisionIds: this.division_ids,
        houseIds: this.house_ids,
        departmentIds: this.dept_ids,
        budgetOwnerIds: this.bo_ids,
        filter: {
          io_number: this.search[0],
          nav_code: this.search[1],
          entity: this.search[2],
          brand: this.search[3],
          house: this.search[4],
          product_hierarchy: this.search[5],
          budget_owner: this.search[21],
          pic: this.search[6],
          cc_desc: this.search[7],
          cost_center: this.search[8],
          cost_element: this.search[9],
          ce_desc: this.search[10],
          material_group: this.search[11],
          nature_activity: this.search[12],
          pillars: this.search[13],
          method: this.search[14],
          campaign: this.search[15],
          bpc_line: this.search[16],
          start: this.search[17],
          end: this.search[18],
          activity_desc: this.search[19],
          year: this.search[20],
          taxonomy_category: this.search[22],
          status: this.search[23],
          january: this.searchmonth[0],
          february: this.searchmonth[1],
          march: this.searchmonth[2],
          april: this.searchmonth[3],
          may: this.searchmonth[4],
          june: this.searchmonth[5],
          july: this.searchmonth[6],
          august: this.searchmonth[7],
          september: this.searchmonth[8],
          october: this.searchmonth[9],
          november: this.searchmonth[10],
          december: this.searchmonth[11],
          department: this.search[24],
          category: this.search[25],
          full_year_io: this.searchmonth[16],
          q1: this.searchmonth[12],
          q2: this.searchmonth[13],
          q3: this.searchmonth[14],
          q4: this.searchmonth[15],
          po: this.search[26],
          non_po: this.search[27],
          remaining_io: this.search[28],
          gr: this.search[29],
          actual_non_po: this.search[30],
          remaining_po: this.search[31],
          remaining_non_po: this.search[32]
        },
        orderBy: this.sortColumn,
        sort: this.sortType,
        page,
        limit: itemsPerPage,
        checkFilter: {
          io_number: this.ceklisSearch[0],
          nav_code: this.ceklisSearch[1],
          entity: this.ceklisSearch[2],
          brand: this.ceklisSearch[3],
          house: this.ceklisSearch[4],
          product_hierarchy: this.ceklisSearch[5],
          budget_owner: this.ceklisSearch[21],
          pic: this.ceklisSearch[6],
          cc_desc: this.ceklisSearch[7],
          cost_center: this.ceklisSearch[8],
          cost_element: this.ceklisSearch[9],
          ce_desc: this.ceklisSearch[10],
          material_group: this.ceklisSearch[11],
          nature_activity: this.ceklisSearch[12],
          pillars: this.ceklisSearch[13],
          method: this.ceklisSearch[14],
          campaign: this.ceklisSearch[15],
          bpc_line: this.ceklisSearch[16],
          start: this.ceklisSearch[17],
          end: this.ceklisSearch[18],
          activity_desc: this.ceklisSearch[19],
          year: this.ceklisSearch[20],
          taxonomy_category: this.ceklisSearch[22],
          status: this.ceklisSearch[23],
          january: this.ceklismonthSearch[0],
          february: this.ceklismonthSearch[1],
          march: this.ceklismonthSearch[2],
          april: this.ceklismonthSearch[3],
          may: this.ceklismonthSearch[4],
          june: this.ceklismonthSearch[5],
          july: this.ceklismonthSearch[6],
          august: this.ceklismonthSearch[7],
          september: this.ceklismonthSearch[8],
          october: this.ceklismonthSearch[9],
          november: this.ceklismonthSearch[10],
          december: this.ceklismonthSearch[11],
          department: this.ceklisSearch[24],
          category: this.ceklisSearch[25],
          full_year_io: this.ceklismonthSearch[16],
          q1: this.ceklismonthSearch[12],
          q2: this.ceklismonthSearch[13],
          q3: this.ceklismonthSearch[14],
          q4: this.ceklismonthSearch[15],
          po: this.ceklisSearch[26],
          non_po: this.ceklisSearch[27],
          remaining_io: this.ceklisSearch[28],
          gr: this.ceklisSearch[29],
          actual_non_po: this.ceklisSearch[30],
          remaining_po: this.ceklisSearch[31],
          remaining_non_po: this.ceklisSearch[32]
        }
      };
      this.$store
        .dispatch('spending/getConsolidatedReport', params)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.itemFilter = data.data.filterBy;
            this.itemConsolidate = data.data.result.result;
            this.itemFilterCheck = data.data.filterChecklist;
            this.totalItems = data.data.result.total_data;
            this.lastPage = data.data.result.pagination.last_page;
            this.itemAmount = data.data.totalAllRes;
            page = data.data.result.pagination.current_page;
            itemsPerPage = data.data.result.pagination.per_page;
            this.options = { page, itemsPerPage };
            this.filtered();
          } else {
            Swal.fire('Failed!', data.response.data.data.error, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_ren, 'error');
        });
    },
    searchCln(obj) {
      this.search[obj.index] = obj.value;
      this.options.page = 1;
      this.getCosolidatedReport();
    },
    searchClnmonth(obj) {
      this.searchmonth[obj.index] = obj.value;
      this.options.page = 1;
      this.getCosolidatedReport();
    },
    checkColumn(obj) {
      this.ceklisSearch = [];
      if (obj.value.length !== 0) {
        this.ceklisSearch[obj.index] = obj.value;
      }
      this.options.page = 1;
      this.getCosolidatedReport();
    },
    checkMonthColumn(obj) {
      this.ceklismonthSearch = [];
      if (obj.value.length !== 0) {
        this.ceklismonthSearch[obj.index] = obj.value;
      }
      this.options.page = 1;
      this.getCosolidatedReport();
    },
    sortBy(obj) {
      this.sortColumn = obj.fieldName;
      this.sortType = obj.value;
      this.options.page = 1;
      this.getCosolidatedReport();
    },
    downloadFile() {
      let division = '';
      let house = '';
      let dept = '';
      let bo = '';
      if (this.division_ids.length > 0) {
        for (var i = 0; i < this.division_ids.length; i++) {
          division += '&divisionIds[]=' + this.division_ids[i];
        }
      }
      if (this.house_ids.length > 0) {
        for (var x = 0; x < this.house_ids.length; x++) {
          house += '&houseIds[]=' + this.house_ids[x];
        }
      }
      if (this.dept_ids.length > 0) {
        for (var y = 0; y < this.dept_ids.length; y++) {
          dept += '&departmentIds[]=' + this.dept_ids[y];
        }
      }
      if (this.bo_ids.length > 0) {
        for (var a = 0; a < this.bo_ids.length; a++) {
          bo += '&budgetOwnerIds[]=' + this.bo_ids[a];
        }
      }
      window.open(
        this.baseUrl +
          '/v1/io/report/filter?type=export&profileId=' +
          this.profile_id +
          '&startYear=' +
          this.filterYear[0] +
          '&endYear=' +
          this.filterYear[1] +
          division +
          house +
          dept +
          bo +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    }
  }
};
</script>
<style scoped>
.drawer-menu--scroll {
  max-height: 340px;
  overflow: auto;
}
.drawer-menu--scrollEdit {
  max-height: 450px;
  overflow: auto;
}
v-dialog {
  overflow-y: hidden !important;
}
.hr-line {
  margin-bottom: 10px;
  margin-top: 20px;
  border: 1px solid rgb(151, 151, 151);
}
.table-po table {
  display: block;
}
.table-po table th,
.table-po table td {
  white-space: nowrap !important;
  height: 30px !important;
}

.table-po table th {
  text-align: center !important;
  font-weight: 500 !important;
}
/* width */
.table-po ::-webkit-scrollbar {
  height: 8px;
}
/* Track */
.table-po ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.table-po ::-webkit-scrollbar-thumb {
  background: #d5d5d5;
  border-radius: 20px;
}

/* Handle on hover */
.table-po ::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}
.table-po td {
  height: 30px !important;
  border-right: 0.1px solid rgba(0, 0, 0, 0.12);
  border-left: 0.1px solid rgba(0, 0, 0, 0.12);
}
td:hover {
  background-color: #f5f5f5 !important;
}
</style>
